import type {
  CollabageddonCreateRequestType,
  CollabageddonCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCollabageddonCreate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: {
      data: CollabageddonCreateRequestType;
      idempotencyKey?: string;
    }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `collabageddon`,
        data: request.data,
        idempotencyKey: request.idempotencyKey,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as CollabageddonCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SCOrders],
      });

      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.LegalEntity],
      });
    },
  });
};
